import { Card, Icon } from '@zillow/constellation-10';
import { IconDollarSignCircleFilled } from '@zillow/constellation-icons';

import EmptyState from '../../../EmptyState';
import InlineStyledText from '../InlineStyledText';

type StyledText = {
  text: string;
  url?: string;
  styling?: string;
};

type Props = {
  title: string;
  description: string;
  ctaLink: {
    text: string;
    url: string;
  };
  ctaPrimaryButton: {
    text: string;
    url: string;
  };
  disclaimer?: Array<StyledText>;
};

const EmptyPaymentsCard = ({ title, description, ctaLink, ctaPrimaryButton, disclaimer }: Props) => (
  <Card
    data-testid="empty-payments-card"
    tone="neutral"
    elevated={false}
    css={{ paddingInline: 'looser', paddingBlock: 'loosest' }}
  >
    <EmptyState
      useCard={false}
      icon={<Icon size="md" css={{ color: 'icon.subtle' }} render={<IconDollarSignCircleFilled />} />}
      heading={title}
      headingLevel={4}
      body={description}
      primaryAction={{ label: ctaPrimaryButton.text, href: ctaPrimaryButton.url }}
      secondaryAction={ctaLink.text && ctaLink.url ? { label: ctaLink.text, href: ctaLink.url } : undefined}
    />
    {disclaimer && (
      <InlineStyledText styledTextList={disclaimer.map((styledText) => ({ styling: 'legal', ...styledText }))} />
    )}
  </Card>
);

export default EmptyPaymentsCard;
